"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
var e = require("./slicedToArray-a539bf82.js"),
  t = require("react"),
  a = require("prop-types"),
  n = require("./taggedTemplateLiteral-97b463ad.js"),
  l = require("styled-components"),
  o = require("polished/lib/helpers/rem"),
  i = require("./grid-965d799c.js"),
  d = require("./typography-fb2881fe.js"),
  r = require("./styles-df7980c2.js");
function g(e) {
  return e && "object" == _typeof(e) && "default" in e ? e : {
    "default": e
  };
}
var u,
  m,
  s,
  f,
  p,
  c,
  b,
  h,
  T,
  k,
  I,
  y,
  x,
  L,
  w,
  j = g(t),
  v = g(a),
  P = g(l),
  _ = g(o),
  O = l.keyframes(u || (u = n._taggedTemplateLiteral(["\n  0% {\n    -webkit-filter: blur(", ");\n    filter: blur(", ");\n  }\n  100% {\n    -webkit-filter: blur(0);\n    filter: blur(0);\n  }\n"])), _["default"](20), _["default"](20)),
  q = P["default"](i.Col)(m || (m = n._taggedTemplateLiteral(["\n  ", ""])), function (e) {
    var t = e.theme.mediumUp();
    return l.css(s || (s = n._taggedTemplateLiteral(["\n      ", ";\n    "])), !t && "padding: 0;");
  }),
  U = P["default"](i.Container)(f || (f = n._taggedTemplateLiteral(["\n  ", ""])), function (e) {
    var t = e.theme.mediumUp();
    return l.css(p || (p = n._taggedTemplateLiteral(["\n      ", ";\n      z-index: 1;\n      margin: 0;\n      ", ";\n    "])), !t && "padding: 0;", t && "height: 100%;");
  }),
  R = P["default"].div(c || (c = n._taggedTemplateLiteral(["\n  ", ""])), function (e) {
    var t,
      a,
      o = e.desktopImage,
      i = e.desktopImageJpg,
      d = e.desktopImageLowRes,
      r = e.desktopImageWebp,
      g = e.imageLoaded,
      u = e.mobileImage,
      m = e.mobileImageJpg,
      s = e.mobileImageLowRes,
      f = e.mobileImageWebp,
      p = e.theme,
      c = p.mediumUp(),
      h = p.smallUp(),
      T = _["default"](120);
    return c ? T = "100%;" : h && (T = _["default"](160)), g || (t = d, a = s), o ? t = o : r ? (t = r, console.warn("desktopImageWebp is deprecated for the FlexibleHero module. Please use desktopImage instead.")) : i ? (t = i, console.warn("desktopImageJpg is deprecated for the FlexibleHero module. Please use desktopImage instead.")) : console.warn("A desktop image prop is required for the FlexibleHero module. Please use desktopImage."), u ? a = u : f ? (a = f, console.warn("mobileImageWebp is deprecated for the FlexibleHero module. Please use mobileImage instead.")) : m ? (a = m, console.warn("mobileImageJpg is deprecated for the FlexibleHero module. Please use mobileImage instead.")) : console.warn("A mobile image prop is required for the FlexibleHero module. Please use mobileImage."), l.css(b || (b = n._taggedTemplateLiteral(["\n      ", ";\n      width: 100%;\n      height: ", ";\n      background: ", " no-repeat scroll 50% 20%;\n      background-position: center;\n      background-image: url(", ");\n      background-size: cover;\n      transform: scale(1);\n      -webkit-animation: ", " 1s both;\n      animation: ", " 1s both;\n      @media print {\n        && {\n          display: none !important;\n        }\n      }\n    "])), c && "\n        position: absolute;\n        top: 0;\n        left: 0;\n      ", T, p.colors.background.lightTheme.heroLazyLoad, c ? t : a, O, O);
  }),
  J = P["default"].div(h || (h = n._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.backgroundVariant,
      a = e.branding,
      o = e.headingTextPosition,
      i = e.theme,
      d = e.themeType,
      g = i.largeUp(),
      u = i.mediumUp(),
      m = "".concat(_["default"](18), " ").concat(_["default"](24), " ").concat(_["default"](10), "}"),
      s = 0,
      f = "center";
    return g && (m = "".concat(_["default"](26), " ").concat(_["default"](48), " ").concat(_["default"](16), "}")), "bottom" === o && (g ? s = _["default"](60) : u && (s = _["default"](48))), u && "left" === o && (f = "flex-start"), l.css(T || (T = n._taggedTemplateLiteral(["\n      background-color: ", ";\n      padding: ", ";\n      margin-bottom: ", ";\n      height: ", ";\n      display: flex;\n      align-items: center;\n      justify-content: ", ";\n    "])), r.getSectionBackgroundColor(t, a, i, d), m, s, g ? "auto" : "100%", f);
  }),
  W = P["default"](i.Row)(k || (k = n._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      a = e.headingTextPosition,
      o = "flex-end";
    return t.mediumUp() && ("left" !== a && "center" !== a || (o = "center")), l.css(I || (I = n._taggedTemplateLiteral(["\n      height: 100%;\n      text-align: left;\n      justify-content: left;\n      align-items: ", ";\n    "])), o);
  }),
  E = P["default"].section(y || (y = n._taggedTemplateLiteral(["\n  ", ""])), function (e) {
    var t = e.theme,
      a = t.xxlargeUp(),
      o = t.xlargeUp(),
      i = t.largeUp(),
      d = t.mediumUp(),
      r = "auto";
    return a ? r = _["default"](660) : o ? r = _["default"](495) : i ? r = _["default"](350) : d && (r = _["default"](265)), l.css(x || (x = n._taggedTemplateLiteral(["\n      overflow: hidden;\n      padding-top: 0;\n      padding-bottom: 0;\n      position: relative;\n      align-items: center;\n      background-color: ", ";\n      color: ", ";\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      width: 100%;\n      height: ", ";\n      text-align: center;\n      padding: 0;\n    "])), t.colors.neutral.white, t.colors.neutral.grayDark20, r);
  }),
  H = P["default"](d.TypographyComponent)(L || (L = n._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      a = e.headingTextPosition,
      o = t.xlargeUp(),
      i = t.largeUp(),
      d = t.mediumUp(),
      r = _["default"](26),
      g = _["default"](32),
      u = _["default"](16),
      m = "center",
      s = "0 auto";
    return o ? (r = _["default"](44), g = _["default"](52)) : i ? (r = _["default"](36), g = _["default"](36)) : d && (r = _["default"](26), g = _["default"](26)), "left" === a && d && (m = "left", s = 0), l.css(w || (w = n._taggedTemplateLiteral(["\n      && {\n        font-family: 'Guardian Sans', 'Helvetica Neue', Helvetica, sans-serif;\n        padding-bottom: ", ";\n        line-height: ", ";\n        font-size: ", ";\n        text-align: ", ";\n        ::after {\n          display: block;\n          width: ", ";\n          padding-bottom: ", ";\n          border-bottom: ", " solid ", ";\n          content: '';\n          text-align: ", ";\n          margin: ", ";\n        }\n      }\n    "])), u, g, r, m, _["default"](60), u, _["default"](4), t.colors.gold.gold, m, s);
  }),
  A = j["default"].forwardRef(function (a, n) {
    var l = a.backgroundImageAriaLabel,
      o = a.backgroundVariant,
      i = a.branding,
      d = a.className,
      r = a.desktopImage,
      g = a.desktopImageJpg,
      u = a.desktopImageLowRes,
      m = a.desktopImageWebp,
      s = a.headingText,
      f = a.headingTextPosition,
      p = a.mobileImage,
      c = a.mobileImageJpg,
      b = a.mobileImageLowRes,
      h = a.mobileImageWebp,
      T = a.sectionId,
      k = a.themeType,
      I = t.useState(!1),
      y = e._slicedToArray(I, 2),
      x = y[0],
      L = y[1],
      w = 3;
    return "left" === f && (w = 0), t.useEffect(function () {
      L(!0);
    }, [g, c]), j["default"].createElement(E, {
      id: "section-".concat(T),
      className: d,
      "data-module": "section-".concat(T, ":flexible-hero-module:A"),
      ref: n,
      role: "banner"
    }, j["default"].createElement(R, {
      id: "background-image-".concat(T),
      imageLoaded: x,
      desktopImage: r,
      desktopImageLowRes: u,
      desktopImageJpg: g,
      desktopImageWebp: m,
      mobileImage: p,
      mobileImageLowRes: b,
      mobileImageJpg: c,
      mobileImageWebp: h
    }, l && j["default"].createElement("span", {
      role: "img",
      "aria-label": l
    })), j["default"].createElement(U, null, j["default"].createElement(W, {
      headingTextPosition: f
    }, j["default"].createElement(q, {
      medium: 6,
      mediumOffset: w
    }, j["default"].createElement(J, {
      backgroundVariant: o,
      branding: i,
      headingTextPosition: f,
      themeType: k
    }, j["default"].createElement(H, {
      id: "flexible-hero-heading-".concat(T),
      component: "h1",
      headingTextPosition: f,
      themeType: k
    }, s))))));
  });
A.propTypes = {
  backgroundImageAriaLabel: v["default"].oneOfType([v["default"].string, v["default"].object]),
  backgroundVariant: v["default"].oneOf(["darkDefault", "lightA", "lightB", "lightC"]),
  branding: v["default"].oneOf(["nm", "pcg"]),
  desktopImageLowRes: v["default"].oneOfType([v["default"].string, v["default"].object]).isRequired,
  desktopImage: v["default"].oneOfType([v["default"].string, v["default"].object]),
  desktopImageJpg: v["default"].oneOfType([v["default"].string, v["default"].object]),
  desktopImageWebp: v["default"].oneOfType([v["default"].string, v["default"].object]),
  mobileImage: v["default"].oneOfType([v["default"].string, v["default"].object]),
  mobileImageLowRes: v["default"].oneOfType([v["default"].string, v["default"].object]),
  mobileImageJpg: v["default"].oneOfType([v["default"].string, v["default"].object]),
  mobileImageWebp: v["default"].oneOfType([v["default"].string, v["default"].object]),
  className: v["default"].string,
  headingText: v["default"].oneOfType([v["default"].string, v["default"].object]).isRequired,
  headingTextPosition: v["default"].oneOf(["left", "center", "bottom"]),
  sectionId: v["default"].string.isRequired,
  themeType: v["default"].oneOf(["lightTheme", "darkTheme", "nmx-pcg"])
}, A.defaultProps = {
  backgroundVariant: "lightB",
  headingTextPosition: "left",
  themeType: "lightTheme"
}, exports.FlexibleHeroComponent = A;